"use client"

import { ThemeProvider as NextThemesProvider } from "next-themes"
import { ComponentProps } from "react";
// import { type ThemeProviderProps } from "next-themes/dist/types"

type ThemeProviderProps = ComponentProps<typeof NextThemesProvider>;

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  return <NextThemesProvider {...props}>{children}</NextThemesProvider>
}
